var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"AccountsCreate"}},[_c('Create',{attrs:{"mode":"accounts","theme":_vm.theme},on:{"on-create":function($event){return _vm.$emit('on-create')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }